import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const UsersReport = () => {
  return <ReportSectionPage scope="org-admin" section="users" title="Users Report" />;
};

export default UsersReport;
